export default __webpack_public_path__ + "static/media/Landing_Logo_UBosque.4321374e.png";